import { WDD } from '../core/wdd.js';

export function opener() {
    const originalButton = WDD.el.querySelector('.bp-hider__button');
    const hiderInput = WDD.el.querySelector('.bp-hider__input');
    const hiderDiv = WDD.el.querySelector('.bp-hider');

    if (!originalButton || !hiderInput || !hiderDiv) return;

    // Duplicate button at end of hider
    const duplicateButton = document.createElement('button');
    duplicateButton.className = originalButton.className.trim();
    duplicateButton.classList.remove('bp-hider__button');
    duplicateButton.classList.add('bp-hider__button--duplicate');
    duplicateButton.innerHTML = originalButton.innerHTML;
    duplicateButton.type = 'button';
    hiderDiv.appendChild(duplicateButton);

    // Toggle arrow classes based on checkbox state
    const toggleArrow = () => {
        const isChecked = hiderInput.checked;
        [originalButton, duplicateButton].forEach(btn => {
            btn.classList.toggle('bp-button--arrow-up', isChecked);
            btn.classList.toggle('bp-button--arrow-down', !isChecked);
        });
    };

    // Duplicate button triggers label click and scrolls to top
    duplicateButton.addEventListener('click', () => {
        originalButton.click();
        WDD.el.scrollIntoView({ behavior: 'smooth' });
    });

    // Track active observer to prevent multiple instances
    let pendingObserver = null;
    const lastChild = hiderDiv.lastElementChild;

    // Update on checkbox state change
    hiderInput.addEventListener('change', () => {
        toggleArrow();
        if (!lastChild) return;

        if (hiderInput.checked) {
            // After CSS transition ends, activate observer to measure scrollHeight
            hiderDiv.addEventListener('transitionend', () => {
                pendingObserver = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            hiderDiv.style.maxHeight = hiderDiv.scrollHeight + 'px';
                            pendingObserver = pendingObserver.unobserve(entry.target);
                        }
                    });
                });
                pendingObserver.observe(lastChild);
            }, { once: true });
        }
        
        else {
            // Clean up observer and clear max-height when collapsing
            hiderDiv.style.removeProperty('max-height');

            if (pendingObserver) {
                pendingObserver = pendingObserver.unobserve(lastChild);
            }
        }
    });

    // Initialize arrow state
    toggleArrow();
    if (hiderInput.checked) {
        hiderDiv.style.maxHeight = hiderDiv.scrollHeight + 'px';
    }
}